import { CHANGE_SELECTED_PROPERTIES } from '../actions/select_list';
import { HIDE_DUPLICATES, SHOW_DUPLICATES } from '../actions/duplicates';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_SELECTED_PROPERTIES:
    return { ...state, selectedPropertyIds: action.properties };
  case HIDE_DUPLICATES:
  case SHOW_DUPLICATES:
    return { ...state, selectedPropertyIds: [] };
  default:
    return state;
  }
}
